/* assets/int-sticky-cta-creator.js
   INT 2026-09-17 PAGE WEIGHT, PASS 2. This is the sticky CTA behaviour from
   snippets/int-sticky-cta-creator.liquid, verbatim, where it was printed inline
   at 4,055 chars on every creator collection page view. It contained no Liquid,
   so it moved without a rewrite.

   WHY A STUB STAYED BEHIND, and do not delete it. The original block did one
   thing AT PARSE TIME on purpose: it added body.int-has-sticky-cta-creator so
   the 64px padding-bottom is reserved from FIRST PAINT. The block's own comment
   records that this replaced a late-class layout shift that used to fire when
   init() added the class at DOMContentLoaded. A deferred asset runs after
   parsing, so moving that line here would have put the shift straight back.
   The snippet therefore keeps a one-line inline stub carrying exactly those two
   statements, at exactly the byte the old block started at, and this file holds
   everything else. The add below is idempotent and harmless as a second call.

   The rest of the timing is unchanged or slightly earlier: init() used to run at
   DOMContentLoaded, and a deferred script runs after parsing but BEFORE
   DOMContentLoaded, so the listeners attach no later than they did.
   Verified live 2026-09-17 on draft 201807429896 at 390px in DK, US and GB. */

(function() {
  'use strict';
  if (window.innerWidth >= 768) {
    /* INT 2026-05: clean up the body class on desktop in case it was added
       by an earlier mobile session in the same tab. The bar itself only
       initializes on mobile. */
    document.body.classList.remove('int-has-sticky-cta-creator');
    return;
  }

  /* INT 2026-05: Add body class synchronously at script parse time so the
     64px padding-bottom is reserved from first paint via the
     body.int-has-sticky-cta-creator rule in the stylesheet above. Eliminates
     the late-class CLS that previously fired when init() added the class at
     DOMContentLoaded. */
  document.body.classList.add('int-has-sticky-cta-creator');

  var bar, infoBlock, btn;
  var isVisible = false;
  var hasShownOnce = false;
  var threshold = 0;
  var rafScheduled = false;

  /* INT 2026-09-11: the bar now reveals immediately on page load. A zero
     threshold means the first update() call from init() shows it with no
     scroll required. Kept as a variable so the resize and orientation
     handlers keep working unchanged. */
  function computeThreshold() {
    threshold = 0;
  }

  function update() {
    rafScheduled = false;
    if (!bar) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var shouldShow = y >= threshold;
    if (shouldShow === isVisible) return;
    isVisible = shouldShow;

    if (shouldShow && !hasShownOnce) {
      hasShownOnce = true;
      bar.setAttribute('data-first-show', '1');
      bar.setAttribute('data-visible', '1');
      var clearFirstShow = function() {
        bar.removeAttribute('data-first-show');
        bar.removeEventListener('animationend', clearFirstShow);
      };
      bar.addEventListener('animationend', clearFirstShow);
      setTimeout(clearFirstShow, 1200);
    } else {
      bar.setAttribute('data-visible', shouldShow ? '1' : '0');
    }
  }

  function onScroll() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(update);
  }

  function onResize() {
    if (!bar) return;
    if (window.innerWidth >= 768) {
      bar.setAttribute('data-visible', '0');
      document.body.classList.remove('int-has-sticky-cta-creator');
    } else {
      computeThreshold();
      document.body.classList.add('int-has-sticky-cta-creator');
      isVisible = false;
      update();
    }
  }

  function setLoading(el, on) {
    if (!el) return;
    el.classList.toggle('is-loading', !!on);
    el.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function clearAllLoading() {
    setLoading(infoBlock, false);
    setLoading(btn, false);
  }

  /* Both info-link and button-link target the same PDP URL.
     Don't preventDefault — the browser navigates and the spinner
     stays up until the new page replaces this one. */
  function onTap() {
    setLoading(btn, true);
    setLoading(infoBlock, true);
  }

  function init() {
    bar = document.getElementById('int-sticky-cta-creator');
    if (!bar) return;
    infoBlock = bar.querySelector('[data-creator-cta="pick"]');
    btn       = bar.querySelector('[data-creator-cta="shop"]');

    if (infoBlock) infoBlock.addEventListener('click', onTap);
    if (btn)       btn.addEventListener('click', onTap);

    bar.hidden = false;
    bar.setAttribute('aria-hidden', 'false');
    bar.setAttribute('data-ready', '1');
    bar.setAttribute('data-visible', '0');
    document.body.classList.add('int-has-sticky-cta-creator');

    computeThreshold();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });

    /* If the user returns via bfcache, clear any stale loading state. */
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) clearAllLoading();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
